module.exports = __webpack_public_path__ + "img/answer_layout_2.37323f89.svg";